/* eslint no-console:0 */

import { installPreloadErrorRecovery } from '../shared/utils/preloadErrorRecovery'

const startup = window.__ROOMSIE_STARTUP__

startup?.mark?.('entrypoint:bootstrap')
installPreloadErrorRecovery()

import('./applicationMain.jsx').then(({ mountApplication }) => {
  startup?.mark?.('entrypoint:main-loaded')
  mountApplication()
}).catch(error => {
  startup?.error?.(error, 'entrypoint:main-import')
  startup?.finish?.('fatal')
  hideNativeSplash()
  renderStartupFailure(error)
})

function hideNativeSplash() {
  window.Capacitor?.Plugins?.SplashScreen?.hide?.({ fadeOutDuration: 100 })?.catch?.(() => {})
}

function renderStartupFailure(error) {
  const loader = document.getElementById('applicationLoader')
  if (loader?.parentNode) loader.parentNode.removeChild(loader)

  const root = document.getElementById('root') || document.body
  const lastEntry = startup?.journal?.entries?.slice(-1)[0]
  const message = error?.message || String(error || 'Unknown startup error')

  root.innerHTML = `
    <div style="box-sizing:border-box;min-height:100vh;padding:calc(env(safe-area-inset-top) + 32px) 24px 32px;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;color:#2D4756;background:#fff;display:flex;align-items:center;justify-content:center;">
      <div style="max-width:420px;width:100%;">
        <h1 style="font-size:24px;line-height:1.25;margin:0 0 12px;">Roomsie could not finish opening</h1>
        <p style="font-size:16px;line-height:1.45;margin:0 0 20px;color:#6b7d87;">Please close and reopen the app. If this keeps happening, send support the startup checkpoint below.</p>
        <button id="roomsieStartupRetry" type="button" style="width:100%;border:0;border-radius:6px;background:#49A486;color:#fff;font-size:16px;font-weight:600;padding:14px 18px;">Try Again</button>
        <details style="margin-top:20px;font-size:12px;line-height:1.5;color:#6b7d87;word-break:break-word;">
          <summary>Startup details</summary>
          <div>Checkpoint: ${escapeHtml(lastEntry?.name || 'unknown')}</div>
          <div>Error: ${escapeHtml(message)}</div>
        </details>
      </div>
    </div>
  `

  document.getElementById('roomsieStartupRetry')?.addEventListener('click', () => {
    window.location.reload()
  })
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
